/**
 * The workspace inbox, one control wherever the shell places it: the rail
 * header, the collapsed rail, and the mobile bar. The accessible name arrives
 * composed by the shell. Unread notices show as a dot on the accent, or as the
 * count when the caller supplies one; neither is announced, because the name
 * already says it.
 */
import { Bell } from "lucide-react";
import { Link } from "react-router";

import { cn } from "@/lib/utils";

interface InboxLinkProps {
  href: string;
  label: string;
  unread: boolean;
  count?: number;
  className?: string;
}

export function InboxLink({ href, label, unread, count, className }: InboxLinkProps) {
  return (
    <Link
      to={href}
      aria-label={label}
      className={cn(
        "relative flex size-[var(--control-height-compact)] shrink-0 items-center justify-center rounded-control text-foreground-soft transition-colors duration-[var(--motion-fast)] ease-[var(--ease-standard)] hover:bg-sidebar-accent hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sidebar-ring",
        className,
      )}
    >
      <Bell className="size-4" strokeWidth={1.75} aria-hidden="true" />
      {unread && count != null && count > 0 ? (
        <span
          aria-hidden="true"
          className="absolute top-1 right-1 flex min-h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 font-data text-key font-semibold text-primary-foreground"
        >
          {count > 99 ? "99+" : count}
        </span>
      ) : unread ? (
        <span
          aria-hidden="true"
          className="absolute top-1.5 right-1.5 size-1.5 rounded-full bg-primary ring-2 ring-sidebar"
        />
      ) : null}
    </Link>
  );
}
